import * as React from 'react';
import { SVGProps } from 'react';

const ArchievementsIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18.047 32.135v-1.458M8.844 29.67l.904-.903M28.984 20.469h1.459M5.648 20.469h1.459M26.344 28.767l.904.904M22.343 16.172a6.077 6.077 0 1 1-8.594 8.594 6.077 6.077 0 0 1 8.594-8.594ZM24.503 8.802H11.582"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m23.402 17.666 5.566-6.239c.476-.534.74-1.225.74-1.941v-3.6a2.925 2.925 0 0 0-2.916-2.917h-17.5a2.916 2.916 0 0 0-2.917 2.916v3.601c0 .716.264 1.407.74 1.941l5.566 6.239M7.207 3.888l9.494 10.66M28.88 3.888l-9.493 10.66"
    />
  </svg>
);
export default ArchievementsIcon;
